import React from "react";
import DataTable from "react-data-table-component";
import { FaEye } from "react-icons/fa"; // Import the eye icon from react-icons
import moment from "moment"; // To format the date
import { Bar, Doughnut } from "react-chartjs-2"; // Import Bar and Doughnut charts
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { useNavigate } from "react-router-dom";

// Register necessary components for Chart.js
ChartJS.register(CategoryScale, LinearScale, BarElement, ArcElement, Title, Tooltip, Legend);

// Sample data for programs and leads

function Reports() {
  const data = [
    { id: 1, program: "PGPM", approvedLeads: 25, rejectedLeads: 5, totalLeads: 30, amount: 150000, paymentStatus: "Paid", utmTag: "PGPM-Campaign", date: "2024-12-01" },
    { id: 2, program: "PGDM", approvedLeads: 20, rejectedLeads: 8, totalLeads: 28, amount: 140000, paymentStatus: "Pending", utmTag: "PGDM-Campaign", date: "2024-12-05" },
    { id: 3, program: "ADR", approvedLeads: 15, rejectedLeads: 10, totalLeads: 25, amount: 120000, paymentStatus: "Paid", utmTag: "ADR-Campaign", date: "2024-12-10" },
    { id: 4, program: "GGU", approvedLeads: 18, rejectedLeads: 4, totalLeads: 22, amount: 110000, paymentStatus: "Paid", utmTag: "GGU-Campaign", date: "2024-12-15" },
    { id: 5, program: "DBA", approvedLeads: 10, rejectedLeads: 3, totalLeads: 13, amount: 80000, paymentStatus: "Pending", utmTag: "DBA-Campaign", date: "2024-12-20" },
  ];

  // Column definition with relevant university lead data
  const columns = [
    { name: "S.No", selector: (row) => row.id, sortable: true },
    { name: "Program", selector: (row) => row.program, sortable: true },
    { name: "Approved Leads", selector: (row) => row.approvedLeads, sortable: true },
    { name: "Rejected Leads", selector: (row) => row.rejectedLeads, sortable: true },
    { name: "Total Leads", selector: (row) => row.totalLeads, sortable: true },
    { name: "Amount (₹)", selector: (row) => row.amount.toLocaleString(), sortable: true },
    { name: "Payment Status", selector: (row) => row.paymentStatus, sortable: true },
    { name: "UTM Tag", selector: (row) => row.utmTag, sortable: true },
    {
      name: "Date",
      selector: (row) => moment(row.date).format("MMMM Do YYYY"), // Format the date
      sortable: true,
    },
    {
      name: "Action",
      selector: (row) => (
        <button
          onClick={() => handleViewClick(row.id)}
          style={{ background: "none", border: "none", cursor: "pointer" }}
        >
          <FaEye />
        </button>
      ),
    },
  ];
  const navigate = useNavigate()

  // Function to handle the "View" button click
  const handleViewClick = (id) => {
    const selectedLead = data.find((item) => item.id === id);
    sessionStorage.setItem("selectedLead", JSON.stringify(selectedLead)); // Store the selected lead in session storage
    navigate(`/reports/view`); // Navigate to the View Page
  };


  // Bar chart data and options
  const barChartData = {
    labels: data.map((item) => item.program), // Use program names as labels
    datasets: [
      {
        label: "Approved Leads",
        data: data.map((item) => item.approvedLeads),
        backgroundColor: "rgba(75, 192, 192, 0.6)",
      },
      {
        label: "Rejected Leads",
        data: data.map((item) => item.rejectedLeads),
        backgroundColor: "rgba(255, 99, 132, 0.6)",
      },
      {
        label: "Total Leads",
        data: data.map((item) => item.totalLeads),
        backgroundColor: "rgba(54, 162, 235, 0.6)",
      },
    ],
  };

  const barChartOptions = {
    responsive: true,
    plugins: {
      legend: { position: "top" },
      title: { display: true, text: "Lead Distribution by Program" },
    },
  };

  // Donut chart data and options
  const donutChartData = {
    labels: data.map((item) => item.program), // Use program names as labels
    datasets: [
      {
        data: data.map((item) => item.totalLeads), // Use total leads as data
        backgroundColor: [
          "rgba(75, 192, 192, 0.6)", // Green
          "rgba(255, 99, 132, 0.6)", // Red
          "rgba(54, 162, 235, 0.6)", // Blue
          "rgba(255, 206, 86, 0.6)", // Yellow
          "rgba(153, 102, 255, 0.6)", // Purple
        ],
        hoverBackgroundColor: [
          "rgba(75, 192, 192, 0.8)",
          "rgba(255, 99, 132, 0.8)",
          "rgba(54, 162, 235, 0.8)",
          "rgba(255, 206, 86, 0.8)",
          "rgba(153, 102, 255, 0.8)",
        ],
      },
    ],
  };

  const donutChartOptions = {
    responsive: true,
    plugins: {
      legend: { position: "bottom" },
      title: { display: true, text: "Total Leads by Program" },
    },
  };

  return (
    <div className="reports">
      <h1>Reports</h1>
      <div  style={{width:"100% !importent",padding:"20px",textAlign:"center"}}>
        There is no data to display
      </div>
    </div>
  );
}

export default Reports
